import { IconProps } from "@/data/types"

export default function PercentIcon({ width=30, height=30, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height}  viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 30.5C23.7843 30.5 30.5 23.7843 30.5 15.5C30.5 7.21573 23.7843 0.5 15.5 0.5C7.21573 0.5 0.5 7.21573 0.5 15.5C0.5 23.7843 7.21573 30.5 15.5 30.5Z" stroke={color} strokeWidth="0.8"/>
      <path d="M9.66699 21.3333L21.3337 9.66663" stroke={color} strokeWidth="0.8" strokeLinecap="round"/>
      <path d="M9.66699 12.1666C11.0477 12.1666 12.167 11.0473 12.167 9.66663C12.167 8.28591 11.0477 7.16663 9.66699 7.16663C8.28628 7.16663 7.16699 8.28591 7.16699 9.66663C7.16699 11.0473 8.28628 12.1666 9.66699 12.1666Z" stroke={color} strokeWidth="0.8"/>
      <path d="M21.333 23.8334C22.7137 23.8334 23.833 22.7141 23.833 21.3334C23.833 19.9527 22.7137 18.8334 21.333 18.8334C19.9523 18.8334 18.833 19.9527 18.833 21.3334C18.833 22.7141 19.9523 23.8334 21.333 23.8334Z" stroke={color} strokeWidth="0.8"/>
      </svg>
    </div>
  )
}